import store from '@sb/store'
import Event from './Event.js'
import PoweredBy from './PoweredBy.js'

var sb = require('@sb/util')

export default {
	props: ['convoKey', 'formMode', 'preForm', 'postForm'],
	data () {
		return {
			...store.bind(this, ['convoEventM']),
			isFetching: false,
			events: [],
		}
	},

	created () {
		this.loadConvo()
	},

	watch: {
		convoKey: function (convoKey, o) {
			this.loadConvo()
		},
	},

	render () {
		if (sb.size(this.events) === 0) {
			return (
				<div ref="body" class="widget-body--events-container">
					<div class="widget-body--empty">
						<div class="widget-body--empty-icon"></div>
						<div class="widget-body--empty-text">{this.$t('empty_convo_text')}</div>
					</div>
					<PoweredBy />
				</div>
			)
		}

		let $events = sb.map(this.events, ev => (
			<Event vOn:formSubmit={this.onFormSubmit} data-ev-id={ev.id} ref={'event.' + ev.id} event={ev} key={ev.id} />
		))

		return (
			<div ref="body" class="widget-body--events-container" data-convo={this.convoKey}>
				<div class="flex-1">{$events}</div>
				<PoweredBy />
			</div>
		)
	},

	methods: {
		onFormSubmit () {
			this.$emit('formSubmit')
		},

		focus () {
			var events = sb.orderBy(
				sb.map(this.convoEventM[this.convoKey], e => e),
				'created',
				'desc',
			)
			// find first msg_sent event of agent
			var last_agent_sent
			for (let ev of events) {
				if (sb.get(ev, 'type') !== 'message_sent') continue
				if (sb.get(ev, 'by.type') === 'user') continue
				last_agent_sent = ev
				break
			}

			if (sb.get(last_agent_sent, 'by.type') === 'user') last_agent_sent = null

			let attachments = sb.get(last_agent_sent, 'data.message.attachments', [])
			let pendingForms = sb.filter(attachments, att => {
				if (!att) return false
				if (att.type !== 'form' && att.type !== 'ask_info_form') return false
				var form = att.form
				if (!form) return false
				var state = sb.parseJSON(form.state) || {}
				if (!state.require_finished && att.type !== 'ask_info_form') return false
				if (form._submitted) return false
				return true
			})

			if (sb.size(pendingForms) > 0) {
				this.$refs['event.' + last_agent_sent.id].focus()
			}
		},

		onEvents (newev) {
			var events = sb.map(store.convoEventM[this.convoKey], ev => ev)
			let isBottom = this.isBottom()
			var byme = false
			this.events = []
			sb.map(events, ev => {
				this.events = upsertConversationEvent(this.events, ev)
			})

			if (sb.get(newev, 'by.id') === store.user.id && sb.get(newev, 'type') === 'message_sent') byme = true

			// scroll to bottom when message is sent by me
			// auto scroll to bottom on new message when we are at the bottom
			if (byme || isBottom) this.scrollToBottom()
		},

		loadConvo () {
			// load msg
			this.events = []

			this.lastContentOffsetY = 0

			store.onConvoEvent(this, ev => this.onEvents(ev))
			// call load in store

			this.onEvents()

			let greeting = sb.get(store.accountSetting, 'greeting', {})
			let byid = greeting.agent_id
			let greetingEvent = {
				id: sb.randomString(36),
				mode: 'lead',
				created: new Date().getTime(),
				type: 'message_sent',
				by: { id: byid, type: 'agent' },
				data: {
					message: {
						text: greeting.message,
						format: 'plaintext',
					},
				},
			}

			// insert greeting message
			if (this.preForm) {
				if (!this.convoKey) {
					this.events = [greetingEvent]
				} else if (this.postForm) {
					this.events.unshift(greetingEvent) // insert greeting to begin
				}
			}

			// insert thanks message
			if (this.postForm) {
				let text = ''
				if (this.formMode === 'offline') text = this.$t('offline_form_thanks')
				if (this.formMode === 'prechat') text = this.$t('prechat_form_thanks')
				this.events.push({
					_thanks: true,
					id: sb.randomString(36),
					created: new Date().getTime() + 5 * 1000, // ensure thanks after user message
					type: 'message_sent',
					by: { id: byid, type: 'agent' },
					data: {
						message: {
							text: text,
							format: 'plaintext',
						},
					},
				})
			}

			// force scroll bottom
			this.scrollToBottom()
			setTimeout(() => this.scrollToBottom(), 300)
		},
		isBottom () {
			let $container = this.$refs.body
			if (!$container) return false
			return $container.scrollHeight === $container.scrollTop + $container.offsetHeight
		},
		scrollToBottom () {
			this.$nextTick(() => {
				const $div = this.$refs.body
				if ($div) $div.scrollTop = $div.scrollHeight
			})
		},
		async loadMore () {
			if (this.loadingMore) return
			this.loadingMore = true

			var convoKey = sb.get(this.props.convo, '_key')
			var err = await store.fetchOlder(convoKey)
			if (err) console.log('err', err)
			this.loadingMore = false
		},

		onScroll (e) {
			var nativeEvent = e.nativeEvent
			var newContentOffsetY = sb.get(nativeEvent, 'contentOffset.y', 0)
			this.lastContentOffsetY = newContentOffsetY
			if (this.loadingMore) return

			var contentMaxOffsetY = sb.get(nativeEvent, 'contentSize.height', 0)
			contentMaxOffsetY -= sb.get(nativeEvent, 'layoutMeasurement.height', 0)

			var lm = sb.shouldLoadMore(newContentOffsetY, contentMaxOffsetY, this.lastContentOffsetY)
			if (lm) return this.loadMore()
		},
	},
}

// sort by time
function upsertConversationEvent (events, ev) {
	if (!sb.get(ev, 'id')) return events
	if (sb.size(events) === 0) return [ev]
	if (!events) events = []

	ev.created = sb.getMs(ev.created)

	// idempotency
	var key = sb.getMsgField(ev, 'idempotency')

	if (key !== ev.id) {
		// a message from server, should remove the sending message
		var found = sb.findIndex(events, event => event.id === key)
		if (found !== -1) {
			events.splice(found, 1) // remove found element
			sb.convertUpdatedOrDeletedMessageEvent(events, found - 1)
		}
	} else {
		// key === ev.id -> new sending message
		// pending message
		// ignore updating event if we already receive it
		var found = events.findIndex(event => {
			if (event.type !== 'message_sent') return false
			var idem = sb.getMsgField(event, 'idempotency')
			if (event.id === idem) return false // pending msg
			// msg received from API
			if (idem === key) return true
			return false
		})
		if (found !== -1) return events // ignore
	}

	// find element by id
	var found = events.findIndex(event => event.id === ev.id)
	if (found !== -1) {
		events.splice(found, 1) // remove found element
		sb.convertUpdatedOrDeletedMessageEvent(events, found - 1)
	}

	for (var i = 0; i < events.length; i++) {
		var event = events[i]
		if (sb.getMs(ev.created) <= sb.getMs(event.created)) {
			events.splice(i, 0, ev)
			sb.convertUpdatedOrDeletedMessageEvent(events, i) // i or i+1 or i-1?
			return events
		}
	}

	events.push(ev)
	sb.convertUpdatedOrDeletedMessageEvent(events, events.length - 1)
	return events
}
